import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { t, getLang } from './i18n';

const stilContainer = { minHeight: '100vh', background: '#F2F8F4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif" };
const stilCard = { background: 'white', borderRadius: 16, padding: '40px 48px', width: 520, border: '1.5px solid #D1E8DA', boxShadow: '0 4px 24px rgba(26,107,60,0.08)' };
const stilLabel = { display: 'block', fontSize: 12, fontWeight: 600, color: '#4B5563', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 8 };
const stilInput = { width: '100%', padding: '10px 12px', border: '1.5px solid #D1E8DA', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 16 };
const stilBtn = { width: '100%', padding: 12, background: '#1A6B3C', color: 'white', border: 'none', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500, cursor: 'pointer' };
const stilBtnSecundar = { width: '100%', padding: 12, background: 'none', color: '#6B7280', border: '1.5px solid #D1E8DA', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, cursor: 'pointer', marginTop: 10 };

// Rețelele pe care aplicația chiar le publică (20 septembrie 2026). Aveau YouTube
// și Twitter/X, rămase din macheta veche: două rețele pe care nu le putem livra,
// bifate de un client care apoi aștepta degeaba. Threads lipsea, deși e construit.
const RETELE = [
  { id: 'facebook', label: 'Facebook', culoare: '#1877F2', bg: '#EBF3FF' },
  { id: 'instagram', label: 'Instagram', culoare: '#E1306C', bg: '#FFF0F5' },
  { id: 'tiktok', label: 'TikTok', culoare: '#010101', bg: '#F0F0F0' },
  { id: 'linkedin', label: 'LinkedIn', culoare: '#0A66C2', bg: '#E8F0FB' },
  { id: 'threads', label: 'Threads', culoare: '#000000', bg: '#F5F5F5' },
  { id: 'x', label: 'X', culoare: '#000000', bg: '#F5F5F5' },
];

export default function Onboarding({ sesiune, onComplet }) {
  const [pas, setPas] = useState(1);
  const [loading, setLoading] = useState(false);
  const [eroare, setEroare] = useState('');
  const [termeniAcceptati, setTermeniAcceptati] = useState(false);
  const [gdprAcceptat, setGdprAcceptat] = useState(false);
  const [date, setDate] = useState({ nume: '', prenume: '', telefon: '', email: sesiune?.user?.email || '' });
  const [reteleSelectate, setReteleSelectate] = useState([]);

  function toggleRetea(id) {
    setReteleSelectate(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
  }

  async function salveazaOnboarding() {
    setLoading(true);
    setEroare('');
    const { error } = await supabase.from('onboarding').upsert({
      user_id: sesiune.user.id,
      completat: true,
      termeni_acceptati: true,
      nume: date.nume,
      prenume: date.prenume,
      telefon: date.telefon,
      email: date.email,
      retele_conectate: reteleSelectate,
    });
    if (error) { setEroare(t('onboarding', 'eroareSalvare')); setLoading(false); return; }
    onComplet();
  }

  const Logo = () => (
    <div style={{ textAlign: 'center', marginBottom: 32 }}>
      <div style={{ width: 44, height: 44, borderRadius: 10, background: '#1A6B3C', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontFamily: "'DM Serif Display', serif", fontSize: 20, color: 'white' }}>N</div>
      <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: '#0F3D22' }}>NM Social</div>
    </div>
  );

  const Progres = () => (
    <div style={{ display: 'flex', gap: 6, marginBottom: 32 }}>
      {[1,2,3,4,5].map(p => (
        <div key={p} style={{ flex: 1, height: 4, borderRadius: 2, background: p <= pas ? '#1A6B3C' : '#E8F5EE' }} />
      ))}
    </div>
  );

  if (pas === 1) return (
    <div style={stilContainer}>
      <div style={stilCard}>
        <Logo />
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 26, color: '#0F3D22', marginBottom: 12 }}>{t('onboarding', 'bunVenit')}</div>
          <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginBottom: 32 }}>{t('onboarding', 'introDurata')}</div>
          <button style={stilBtn} onClick={() => setPas(2)}>{t('onboarding', 'haiSaIncepem')}</button>
        </div>
      </div>
    </div>
  );

  if (pas === 2) return (
    <div style={stilContainer}>
      <div style={stilCard}>
        <Logo />
        <Progres />
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: '#0F3D22', marginBottom: 8 }}>{t('onboarding', 'termeniTitlu')}</div>
        <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 20 }}>{t('onboarding', 'termeniSubtitlu')}</div>
        <div style={{ background: '#F9FCF9', border: '1px solid #E8F5EE', borderRadius: 10, padding: 16, fontSize: 13, color: '#374151', lineHeight: 1.7, marginBottom: 20, maxHeight: 200, overflowY: 'auto' }}>
          {getLang() === 'en' ? (<>
            <strong>NM Social Terms and Conditions</strong><br /><br />
            By using the NM Social platform, you agree to the following:<br /><br />
            <strong>1. The service</strong><br />
            NM Social is a social media management platform provided by New Mind. By connecting your social accounts, you authorise New Mind to post content on your behalf, according to your instructions.<br /><br />
            <strong>2. Responsibility</strong><br />
            You are responsible for the content approved and published on your accounts. New Mind acts solely according to your instructions.<br /><br />
            <strong>3. Confidentiality</strong><br />
            Your personal data is stored securely and is not shared with third parties without your explicit consent.<br /><br />
            <strong>4. Termination</strong><br />
            You may request deletion of your account and your data at any time by contacting the New Mind team.
          </>) : (<>
            <strong>Termeni și condiții NM Social</strong><br /><br />
            Prin utilizarea platformei NM Social, ești de acord cu următoarele:<br /><br />
            <strong>1. Serviciul</strong><br />
            NM Social este o platformă de management al rețelelor sociale oferită de New Mind. Prin conectarea conturilor tale sociale, autorizezi New Mind să posteze conținut în numele tău, conform instrucțiunilor tale.<br /><br />
            <strong>2. Responsabilitate</strong><br />
            Ești responsabil pentru conținutul aprobat și publicat pe conturile tale. New Mind acționează exclusiv conform instrucțiunilor tale.<br /><br />
            <strong>3. Confidențialitate</strong><br />
            Datele tale personale sunt stocate securizat și nu sunt partajate cu terți fără acordul tău explicit.<br /><br />
            <strong>4. Reziliere</strong><br />
            Poți solicita ștergerea contului și a datelor tale oricând, prin contactarea echipei New Mind.
          </>)}
        </div>
        <div style={{ background: '#F9FCF9', border: '1px solid #E8F5EE', borderRadius: 10, padding: 16, fontSize: 13, color: '#374151', lineHeight: 1.7, marginBottom: 20, maxHeight: 160, overflowY: 'auto' }}>
          {getLang() === 'en' ? (<>
            <strong>Privacy policy (GDPR)</strong><br /><br />
            We collect: last name, first name, email, phone and the access details for the connected social accounts.<br /><br />
            We use this data solely to manage your presence on social networks as part of the NM Social service.<br /><br />
            We do not sell or share your data with third parties. You have the right to access, rectify and erase your data. For any request: contact@newmind.ro
          </>) : (<>
            <strong>Politică de confidențialitate (GDPR)</strong><br /><br />
            Colectăm: nume, prenume, email, telefon și datele de acces la rețelele sociale conectate.<br /><br />
            Folosim aceste date exclusiv pentru a gestiona prezența ta pe rețelele sociale în cadrul serviciului NM Social.<br /><br />
            Nu vindem și nu partajăm datele tale cu terți. Ai dreptul de acces, rectificare și ștergere a datelor tale. Pentru orice solicitare: contact@newmind.ro
          </>)}
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, cursor: 'pointer', fontSize: 13, color: '#374151' }}>
          <input type="checkbox" checked={termeniAcceptati} onChange={e => setTermeniAcceptati(e.target.checked)} />
          {t('onboarding', 'acceptTermeni')}
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24, cursor: 'pointer', fontSize: 13, color: '#374151' }}>
          <input type="checkbox" checked={gdprAcceptat} onChange={e => setGdprAcceptat(e.target.checked)} />
          {t('onboarding', 'acceptGdpr')}
        </label>
        <button style={{ ...stilBtn, background: termeniAcceptati && gdprAcceptat ? '#1A6B3C' : '#D1E8DA', color: termeniAcceptati && gdprAcceptat ? 'white' : '#9CA3AF', cursor: termeniAcceptati && gdprAcceptat ? 'pointer' : 'not-allowed' }} disabled={!termeniAcceptati || !gdprAcceptat} onClick={() => setPas(3)}>{t('onboarding', 'continua')}</button>
      </div>
    </div>
  );

  if (pas === 3) return (
    <div style={stilContainer}>
      <div style={stilCard}>
        <Logo />
        <Progres />
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: '#0F3D22', marginBottom: 8 }}>{t('onboarding', 'datePersonale')}</div>
        <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 24 }}>{t('onboarding', 'dateSubtitlu')}</div>
        <label style={stilLabel}>{t('onboarding', 'nume')}</label>
        <input style={stilInput} placeholder={t('onboarding', 'exNume')} value={date.nume} onChange={e => setDate(p => ({ ...p, nume: e.target.value }))} />
        <label style={stilLabel}>{t('onboarding', 'prenume')}</label>
        <input style={stilInput} placeholder={t('onboarding', 'exPrenume')} value={date.prenume} onChange={e => setDate(p => ({ ...p, prenume: e.target.value }))} />
        <label style={stilLabel}>{t('onboarding', 'telefon')}</label>
        <input style={stilInput} placeholder={t('onboarding', 'exTelefon')} value={date.telefon} onChange={e => setDate(p => ({ ...p, telefon: e.target.value }))} />
        <label style={stilLabel}>{t('onboarding', 'email')}</label>
        <input style={stilInput} placeholder={t('onboarding', 'exEmail')} value={date.email} onChange={e => setDate(p => ({ ...p, email: e.target.value }))} />
        <button style={{ ...stilBtn, background: date.nume && date.prenume && date.telefon && date.email ? '#1A6B3C' : '#D1E8DA', color: date.nume && date.prenume && date.telefon && date.email ? 'white' : '#9CA3AF', cursor: date.nume && date.prenume && date.telefon && date.email ? 'pointer' : 'not-allowed' }} disabled={!date.nume || !date.prenume || !date.telefon || !date.email} onClick={() => setPas(4)}>{t('onboarding', 'continua')}</button>
      </div>
    </div>
  );

  if (pas === 4) return (
    <div style={stilContainer}>
      <div style={stilCard}>
        <Logo />
        <Progres />
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: '#0F3D22', marginBottom: 8 }}>{t('onboarding', 'conecteazaRetele')}</div>
        <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 24 }}>{t('onboarding', 'reteleSubtitlu')}</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
          {RETELE.map(r => (
            <label key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 16px', border: `1.5px solid ${reteleSelectate.includes(r.id) ? r.culoare : '#D1E8DA'}`, borderRadius: 10, cursor: 'pointer', background: reteleSelectate.includes(r.id) ? r.bg : 'white', transition: 'all 0.15s' }}>
              <input type="checkbox" checked={reteleSelectate.includes(r.id)} onChange={() => toggleRetea(r.id)} />
              <span style={{ fontSize: 14, fontWeight: 500, color: reteleSelectate.includes(r.id) ? r.culoare : '#374151' }}>{r.label}</span>
            </label>
          ))}
        </div>
        <button style={stilBtn} onClick={() => setPas(5)}>{t('onboarding', 'continua')}</button>
        <button style={stilBtnSecundar} onClick={() => setPas(5)}>{t('onboarding', 'sarPeste')}</button>
      </div>
    </div>
  );

  if (pas === 5) return (
    <div style={stilContainer}>
      <div style={stilCard}>
        <Logo />
        <Progres />
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
          <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, color: '#0F3D22', marginBottom: 12 }}>{t('onboarding', 'totulSetat')}</div>
          <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginBottom: 32 }}>{t('onboarding', 'finalMesaj', { nume: date.prenume })}</div>
          {eroare && <div style={{ background: '#FEE2E2', color: '#DC2626', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>{eroare}</div>}
          <button style={{ ...stilBtn, opacity: loading ? 0.7 : 1 }} disabled={loading} onClick={salveazaOnboarding}>{loading ? t('onboarding', 'seSalveaza') : t('onboarding', 'intraInCont')}</button>
        </div>
      </div>
    </div>
  );
}